import { render } from "./DepartmentEdit.vue?vue&type=template&id=1974d0b6&scoped=true"
import script from "./DepartmentEdit.vue?vue&type=script&lang=js"
export * from "./DepartmentEdit.vue?vue&type=script&lang=js"

import "./DepartmentEdit.vue?vue&type=style&index=0&id=1974d0b6&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1974d0b6"]])

export default __exports__